module.exports = __webpack_public_path__ + "static/post-image-e068a30399960e073c2348de5e25afd7.png";